"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDefaultFloor = void 0;
const useSiteManifest_1 = require("./useSiteManifest");
function useDefaultFloor() {
    var _a;
    const [{ data: manifest, loading }] = useSiteManifest_1.useSiteManifest();
    const defaultFloor = Object.entries((_a = (manifest !== null && manifest !== void 0 ? manifest : {}).floors) !== null && _a !== void 0 ? _a : {}).reduce((agg, [floorLevel, { default: isDefault }]) => isDefault ? Number(floorLevel) : agg !== null && agg !== void 0 ? agg : Number(floorLevel), null);
    return { loading, data: defaultFloor };
}
exports.useDefaultFloor = useDefaultFloor;
//# sourceMappingURL=useDefaultFloor.js.map